import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { sinSelloDeError } from "src/app/shared/http/sello-de-error";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import {
  Cliente,
  ClienteNuevo,
  ModuloDisponible,
  Plan,
} from "src/app/shared/model/security/plan.model";
import { MenuEstructura } from "src/app/shared/model/security/menu-estructura.model";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";

/**
 * Plataforma (Solser): clientes y sus planes. Todo lo que se manda lleva el
 * corporativo del cliente explícito; el backend además exige el menú de
 * Plataforma en cada llamada.
 */
@Injectable({
  providedIn: "root",
})
export class PlataformaService {
  constructor(private http: HttpClient) {}

  consultarClientes(): Observable<ConsultaList<Cliente>> {
    return this.http.post<ConsultaList<Cliente>>(UrlConstantes.PLATAFORMA_CLIENTES_CONSULTAR, {});
  }

  /** El backend regresa el cliente ya creado dentro de la lista. */
  crearCliente(alta: ClienteNuevo): Observable<ConsultaList<Cliente>> {
    return this.http.post<ConsultaList<Cliente>>(UrlConstantes.PLATAFORMA_CLIENTES_CREAR, alta);
  }

  consultarPlanes(idCliente: number): Observable<ConsultaList<Plan>> {
    return this.http.post<ConsultaList<Plan>>(UrlConstantes.PLATAFORMA_PLANES_CONSULTAR, { idCliente });
  }

  consultarModulosDisponibles(idCliente: number): Observable<ConsultaList<ModuloDisponible>> {
    return this.http.post<ConsultaList<ModuloDisponible>>(UrlConstantes.PLATAFORMA_PLANES_MODULOS, {
      idCliente,
    });
  }

  // ---------------------------------------------------------------- menú

  /** El menú completo (todas las empresas), como grupos con sus opciones. */
  consultarMenu(): Observable<MenuEstructura> {
    return this.http
      .post<MenuEstructura>(UrlConstantes.PLATAFORMA_MENU_CONSULTAR, {}, { observe: "response" })
      .pipe(sinSelloDeError("No se pudo consultar el menú."));
  }

  /** Aplica la estructura completa; regresa cómo quedó. */
  guardarMenu(estructura: MenuEstructura): Observable<MenuEstructura> {
    return this.http
      .post<MenuEstructura>(UrlConstantes.PLATAFORMA_MENU_GUARDAR, estructura, { observe: "response" })
      .pipe(sinSelloDeError("No se pudo guardar el menú."));
  }

  /** El backend regresa el plan ya guardado (con id y licencias ocupadas) dentro de la lista. */
  guardarPlan(plan: Plan): Observable<ConsultaList<Plan>> {
    return this.http.post<ConsultaList<Plan>>(UrlConstantes.PLATAFORMA_PLANES_GUARDAR, plan);
  }
}
